import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

// Utils
import * as Database from "utils/database.utils";

// Components
import HomeList from "../../../Home/HomeList/HomeList";
import ExtractionRow from "../ExtractionRow/ExtractionRow";

// Context
import { useSettings } from "context/Settings.context";

// Styles
import HoldingExtractionsContainer from "./HoldingExtractions.styles";
import { useNotifications } from "../../../../../context/Notifications.context";

export default function HoldingExtractions() {
    const history = useHistory();
    const { setDefaultFilters } = useSettings();
    const { setHoldingCompanyExtractions } = useNotifications();

    const [loading, setLoading] = useState(true);
    const [data, setData] = useState([]);
    const [total, setTotal] = useState(0);

    const getHoldingExtractions = async () => {
        let res = await Database.get(
            "api/extractions?page=1&pageSize=1000&sortKey=extraction_datetime&sortOrder=DESC&filter_model_status=HLD"
        );
        let data = await res.json();

        setData(data.data);
        setTotal(data.total);
        setHoldingCompanyExtractions(data.total);
        setLoading(false);
    };

    useEffect(() => {
        setLoading(true);
        getHoldingExtractions();
    }, []);

    return (
        <HoldingExtractionsContainer>
            <HomeList
                data={data}
                row={(row: any) => <ExtractionRow data={row} />}
                title={"HOLDING EXTRACTIONS"}
                count={total}
                countColor={"holding"}
                loading={loading}
                seeAll={() => {
                    setDefaultFilters({ model_status: "HLD" });
                    history.push("/data/company-models");
                }}
                maxRows={5}
            />
        </HoldingExtractionsContainer>
    );
}
